import { render, staticRenderFns } from "./ProjPublishDialog.vue?vue&type=template&id=4bc0fe3b&scoped=true"
import script from "./ProjPublishDialog.vue?vue&type=script&lang=js"
export * from "./ProjPublishDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjPublishDialog.vue?vue&type=style&index=0&id=4bc0fe3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0fe3b",
  null
  
)

export default component.exports